import { render, staticRenderFns } from "./InnerPage_sxzj.vue?vue&type=template&id=172083a6&"
import script from "./InnerPage_sxzj.vue?vue&type=script&lang=js&"
export * from "./InnerPage_sxzj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports